import { render, staticRenderFns } from "./Generate.vue?vue&type=template&id=f15d06fc&scoped=true&"
import script from "./Generate.vue?vue&type=script&lang=js&"
export * from "./Generate.vue?vue&type=script&lang=js&"
import style0 from "./Generate.vue?vue&type=style&index=0&id=f15d06fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15d06fc",
  null
  
)

export default component.exports